import { useSuspenseQuery } from '@tanstack/react-query';

import { getTechnologicalTransferValidationHistoryOptions } from '@/module/Author/TechnologicalTransfer/Validation/model/TechnologicalTransferValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface TechnologicalTransferValidationHistoryProps {
  technologicalTransferId: Id;
}

export function TechnologicalTransferValidationHistory({
  technologicalTransferId,
}: TechnologicalTransferValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getTechnologicalTransferValidationHistoryOptions(technologicalTransferId));

  return <ValidationHistoryContent history={history} />;
}
